import { render, staticRenderFns } from "./DataPanelCenter.vue?vue&type=template&id=0842e1f3&scoped=true&xmlns=true"
import script from "./DataPanelCenter.vue?vue&type=script&lang=js"
export * from "./DataPanelCenter.vue?vue&type=script&lang=js"
import style0 from "./DataPanelCenter.vue?vue&type=style&index=0&id=0842e1f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0842e1f3",
  null
  
)

export default component.exports